import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.35 0 9.76-4.19 9.99-9.5V11H12v3h6.63A6.99 6.99 0 1 1 12 5c1.72 0 3.29.62 4.5 1.64l2.16-2.16A9.96 9.96 0 0 0 12 2" }, null, -1)
  ]))]))
}
export default { render: render }